<template>
	<div>
		
		<!--  -->
		<popdrawer  ref="sfdrawer" :show.sync="drawershow"  @retuheig="(e)=>{row_height = e.height}">
			<template slot="head">
				
				<div class="head_info">
					<div class="leftb">
						<div class="tx_box" v-if="curfield_power.head_image != 3">
							<img :src="drawer_info.head_image" v-if="drawer_info.head_image">
							<img v-else src="~assets/img/def_icon.png">
						</div>
						<div class="info_name">
							<div class="name danhang" v-if="page_power.customer_name != 3">
								{{ drawer_info.customer_name || '' }}
							</div>
							<div class="qy_name ">
								<el-tag class="tagstyle" v-if="drawer_info.customer_type == 1">
									企业客户
								</el-tag>
								<el-tag class="tagstyle" v-else-if="drawer_info.customer_type == 2">
									个人客户
								</el-tag>
								<el-tag class="tagstyle" v-else-if="drawer_info.customer_type == 3">
									其他客户
								</el-tag>
							</div>
				
						</div>
					</div>
				
					<div class="rightb">
						<!-- <div class="drawer_btn style1" @click="head_btnClick(1)">
							转为客户
						</div> -->
						<div class="drawer_btn style1" @click="head_btnClick(2)">
							分配客户
						</div>
						<div class="drawer_btn style1" @click="head_btnClick(3)">
							编辑
						</div>
						<!-- <el-dropdown>
							<div class="drawer_btn style2">
								<i class="el-icon-more"></i>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="1" @click.native="switchState(1)">删除客户
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown> -->
					</div>
				</div>
				
				<div class="info_list">
					<!--  -->
					<div class="infl_item" :title="drawer_info.qy_name" v-if="page_power.qy_name != 3">
						<div class="infl__tit">
							企业名称
						</div>
						<div class="infl_txt danhang">
							{{ drawer_info.qy_name || '暂无' }}
						</div>
				
					</div>
					<!--  -->
					<!--  -->
					<div class="infl_item" v-if="curfield_power.follow_id != 3">
						<div class="infl__tit">
							跟进阶段
						</div>
						<div class="infl_txt danhang">
							<span>
								{{ drawer_info.follow_up_stage || '暂无' }}
							</span>
						</div>
				
					</div>
					<!--  -->
					<!--  -->
					<div class="infl_item">
						<div class="infl__tit">
							客户状态
						</div>
						<div class="infl_txt danhang">
							<span v-if="drawer_info.state === 0">未成交</span>
							<span v-else-if="drawer_info.state === 1">已成交</span>
							<span v-else>
								暂无
							</span>
						</div>
				
					</div>
					<!--  -->
					<!--  -->
					<div class="infl_item" :title="drawer_info.create_time" v-if="curfield_power.create_time != 3">
						<div class="infl__tit">
							添加时间
						</div>
						<div class="infl_txt danhang">
							{{ drawer_info.create_time || '暂无' }}
						</div>
				
					</div>
					<!--  -->
					<!--  -->
					<div class="infl_item" :title="drawer_info.follow_time" v-if="curfield_power.follow_time != 3">
						<div class="infl__tit">
							最后跟进时间
						</div>
						<div class="infl_txt danhang">
							{{ drawer_info.follow_time || '暂无' }}
						</div>
				
					</div>
					<!--  -->
				
				</div>
				
			</template>
			<template slot="body">
				<el-tabs v-model="activeName" v-show="drawershow">
				    <el-tab-pane label="动态" name="1">
						<!--  -->
						<div class="drawer_row" :style="row_height">
							<!-- -->
							<div class="Stage_box">
								<!-- 动态 -->
								<dynamics :show="activeName == '1'"  :customer_id="customer_id" ></dynamics>
								<!--  -->
							</div>
							<div class="label_bopx">
								<div class="tit">
									客户标签：
								</div>
								<div class="label_lists">
									<el-tag v-for="(item, index) in drawer_info.tag">{{ item.name || '' }}</el-tag>
								</div>
								<div class="label_addbtn FlexRow" @click="addlabel_btn">
									+
								</div>
							</div>
							<!--  -->
						</div>
						<!--  -->
					</el-tab-pane>
					<!--  -->
					
				    <el-tab-pane :label="'联系人' + (r_navlist[1].num ? `(${r_navlist[1].num})` : '')" name="2">
						<!--  -->
						<div class="drawer_row bg1"  :style="row_height">
							<relacuscontacts :drawerinfo="drawer_info" :customer_id="customer_id" :show.sync="tactshow"
								@retunm="(e) => { r_navlist[1].num = e.num }" @retcontacs="getcontacs"></relacuscontacts>
						</div>
						<!--  -->
					</el-tab-pane>
				    <el-tab-pane label="详细" name="3">
						<!--  -->
						<div class="drawer_row" :style="row_height">
							<detailedbox :fieldlist="field_data" :loading="create_loading" :createlist="basics_list">
							</detailedbox>
						</div>
						<!--  -->
						
					</el-tab-pane>
					<!--  --> 
				    <el-tab-pane label="跟进" name="4">
						<div class="drawer_row" :style="row_height">
							<followupbox ref="sfollow" :show="activeName == '4'" :customer_id="customer_id" v-if="customer_id"></followupbox>
						</div>
					</el-tab-pane>
					<!--  -->
					<!--  --> 
					<el-tab-pane :label="'商机' + (r_navlist[4].num ? `(${r_navlist[4].num})` : '')" name="5">
						<div class="drawer_row bg1" :style="row_height">
							<relacuschance :customer_id="customer_id" :show="tactshow"
								@retunm="(e) => { r_navlist[4].num = e.num }">
							</relacuschance>
						</div>
					</el-tab-pane>
					<!--  -->
					<!--  -->
					<el-tab-pane :label="'项目' + (r_navlist[5].num ? `(${r_navlist[5].num})` : '')" name="6">
						<div class="drawer_row bg1" :style="row_height">
							<relacusproject :customer_id="customer_id" :show="tactshow"
								@retunm="(e) => { r_navlist[5].num = e.num }">
							</relacusproject>
						</div>
					</el-tab-pane>
					<!--  -->
					<!--  -->
					<el-tab-pane :label="'合同' + (r_navlist[6].num ? `(${r_navlist[6].num})` : '')" name="7">
						<div class="drawer_row bg1" :style="row_height">
							<relacuscontract :customer_id="customer_id" :show="tactshow"
								@retunm="(e) => { r_navlist[6].num = e.num }">
							</relacuscontract>
						</div>
					</el-tab-pane>
					<!--  -->
					<!--  -->
					<el-tab-pane :label="'回款' + (r_navlist[7].num ? `(${r_navlist[7].num})` : '')" name="8">
						<div class="drawer_row bg1" :style="row_height">
							<relacusreturn :customer_id="customer_id" :show="tactshow"
								@retunm="(e) => { r_navlist[7].num = e.num }">
							</relacusreturn>
						</div>
					</el-tab-pane>
					<!--  -->
					<!--  -->
					<el-tab-pane :label="'订单' + (r_navlist[8].num ? `(${r_navlist[8].num})` : '')" name="9">
						<div class="drawer_row bg1" :style="row_height">
							
						</div>
					</el-tab-pane>
					<!--  -->
			
				  </el-tabs>
			</template>
		</popdrawer>
		<!--  -->
		
		<!-- 分配客户  -->
		<possession :show.sync="zhuanR_show" @addxzr="headsave"></possession>
		<!--  -->
		
		<!-- 添加客户标签 -->
		<addlabels :show.sync="labelshow" @fnsuccess="fnsuccess" :customer_id="customer_id"
			:checklist="drawer_info.tag"></addlabels>
		<!--  -->
		
		<!--   -->
		<!-- <fieldcreate ref="reffield" :savenew="savenew" :show.sync="create_show" :fieldlist="field_create"
			:title="create_info.name" :loading="create_loading" :createlist="basics_list" @saveer="headsaveer"
			@chakan="fn_chaskan" @fjdelet="fndelet" @fjadds="setupfile"></fieldcreate> -->
		
		<newfieldcreate ref="reffield" :savenew="savenew" :show.sync="create_show" :fieldlist="field_create"
			:title="create_info.name" :loading="create_loading" :createlist="basics_list" @saveer="headsaveer"
			@chakan="fn_chaskan" @fjdelet="fndelet" @fjadds="setupfile"></newfieldcreate>
		<!--  -->
		
	</div>
</template>

<script>
	import popdrawer from "@/components/content/publics/popdrawer.vue";
	import relacuscontacts from "components/content/contacts/relacuscontacts";
	import relacuschance from "components/content/contacts/relacuschance";
	import relacusproject from "components/content/contacts/relacusproject";
	import relacuscontract from "components/content/contacts/relacuscontract";
	import relacusreturn from "components/content/contacts/relacusreturn";
	import followupbox from "components/content/addproduct/followupbox";
	import dynamics from "components/content/addproduct/dynamics";
	import addlabels from "components/content/addproduct/addlabels";
	import possession from "components/content/addproduct/possession";
	import fieldcreate from "components/content/addproduct/fieldcreate";
	import newfieldcreate from "components/content/addproduct/newfieldcreate";
	let that
	
	import {
		getCustomerInfoStoreConfig,
		getfollow_up_list,
		
		editCustome2,
		lxrl_add_contact,
		lxrl_edit_contact,
		lxr_list2confield,
		distributePublicCustomer,
		delPublicCustomer,
		
		getCustomerDetails,
		get_qw_customer_details, 
	} from 'network/hk_customer'
	import {
		handErrJson,
		fn_newfield,
		Basics_kehu,
		Basics_field,
	} from 'network/hk_operset'
	
	import {
		handlereq ,
		retupower,
		alertMess,
		retfieldPower,
		fn_fielddisabled ,
		
	} from 'network/kh_public'
	
	export default {
		components: {
			possession,
			addlabels,
			followupbox,
			dynamics,
			relacuscontacts,
			relacuschance,
			relacusproject,
			relacuscontract,
			relacusreturn,
			popdrawer,
			fieldcreate,
			newfieldcreate,
		},
		
		data() {
			return {
				drawershow: false,
				page_power: {},
				fieldConfig:'',
				curfield_power: '',
				curkey: 'seas_customer',
				is_powerAdd: false,
				is_powerEdit: false,
				is_powerDel: false,
				is_powerImp: false,
				is_powerExp: false,
				is_powerRec: false,
				// ------------------
				datapage: {
					pagesize: 20,
					page: 1,
					total: 0,
					lsit: [],
				},
				check_list: [],
				// ------------------
				
				
				tactshow: false,
				savenew: true,
				drawer_loading: true,
				labelshow: false,
		
				create_loading: true,
		
				table_loading: true,
				//
				batch_edit: false,
				pro_show: false,
		
		
		
		
				//
				// ------------------
				customer_id: '',
				activeName: '0',
				r_navlist: [{
						name: '动态',
						num: 0,
					},
					{
						name: '联系人',
						num: 0,
					},
					{
						name: '详细',
						num: 0,
					},
					{
						name: '跟进',
						num: 0,
					},
					{
						name: '商机',
						num: 0,
					},
					{
						name: '项目',
						num: 0,
					},
					{
						name: '合同',
						num: 0,
					},
					{
						name: '回款',
						num: 0,
					},
					{
						name: '订单',
						num: 0,
					},
		
				],
				edit_show1: false,
		
				field_create: [],
				field_data: [],
				field_initial: [],
				drawer_info: '',
				// 
				create_show: false,
				create_info: {
					name: '编辑详细',
					width: '916px'
				},
		
				basics_list: [{
						name: '基础信息',
						type: 1,
					},
					{
						name: '联系信息',
						type: 2,
					},
					{
						name: '企业信息',
						type: 3,
					},
					{
						name: '身份信息',
						type: 4,
					},
				],
				// 图片头部
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
		
				zhuanR_show: false,
		
				member_list: [],
		
				// 
				source_select: [],
				// ------------------------------------
				createlistlxr: [],
				currentContact: '',
		
				lxr_list: [],
				lxr_loading: true,
				
		
				field_batch: [],
				
				import_show: false,
				thisfileurl: '',
				currentSelect_id: '',
				// ------------------------
				row_height: '',
				
			}
		},
		props: {
			userid: {
				type: String,
				default: '',
			}
		},
		created() {
			
			that = this
			
			
			
			
		},
		mounted() {
			window.onresize = () => {
				// 取消所有正在请求的接口
				if(this.$refs.sfdrawer) {
					this.$refs.sfdrawer.getvanhe();
				}
			}
		},
		watch: {
			activeName(){
				if(this.activeName == '3') {
					this.edit_show1 = false
					this.fn_getConfig(3)
				}
			},
			drawershow() {
				if (!this.drawershow) {
					this.currentContact = ''
					this.tactshow = false
					this.field_initial = []
					this.field_data = []
					this.field_create = []
		
					this.drawer_info = ''
					this.activeName = '0'
					this.customer_id = ''
		
					this.create_loading = true
		
					for (let item of this.r_navlist) {
						item.num = 0
					}
				}
				else {
					this.fn_initial()
					
				}
			},
			
			
		},
		
		methods: {
			fn_chaskan(e) {
				let {
					query
				} = e
				console.log(query, ';query')
				this.search_name = query
				this.data.page = 1
				this.fn_tabledata()
			},
			fn_initial(){
				this.activeName = '1'
				
				this.fn_getConfig()
				this.curfield_power = retfieldPower(this.curkey)
						
				// 获取客户来源
				this.fn_follow_up_list()
				this.judgePower()
				if(this.userid) {
					this.fn_getDelait()
				}
				//  userid
			},
			judgePower() {
				this.is_powerAdd = retupower('86')
				this.is_powerEdit = retupower('87')
				this.is_powerDel = retupower('88')
				this.is_powerImp = retupower('89')
				this.is_powerExp = retupower('90')
				this.is_powerRec = retupower('91')
			},
			// 添加客户标签
			addlabel_btn(){
				if(this.is_powerAdd) {
					this.labelshow = true
				}
				else {
					alertMess('无权限操作', 'warning')
				}
			},
			// 删除 附件 图片 field_id  
			fndelet(e) {
				let index1 = this.field_create.findIndex(v => v.field == '创建联系人')
				if (index1 != -1) {
					let obj = this.field_create[index1].lxr_list
					let index2 = obj.findIndex(v => v.field_id == e.id)
					if (index2 != -1) {
						obj[index2].content.splice(e.index, 1)
					}
				}
			},
			// 新增 附件 图片
			setupfile(e) {
				let index1 = this.field_create.findIndex(v => v.field == '创建联系人')
				if (index1 != -1) {
					let obj = this.field_create[index1].lxr_list
					let index2 = obj.findIndex(v => v.field_id == e.id)
					if (index2 != -1) {
						if (e.newArr.length) {
							for (let item of e.newArr) {
								obj[index2].content.push(item)
							}
						}
					}
				}
			},
			getcontacs(e) {
				let {
					obj
				} = e
				this.currentContact = obj
			}, 
			headsave(arr) {
				console.log(arr, 'arr')
				let customer_id = ''
				if (this.batch_edit) {
					let newArr = []
					for (let item of this.check_list) {
						newArr.push(item.customer_id)
					}
					customer_id = newArr.join(',')
				} else {
					customer_id = this.customer_id
				}
				this.distributeCuePool(customer_id, arr[0])
			},
			// 转让客户 分配客户 
			distributeCuePool(customer_id, member_id) {
				distributePublicCustomer(customer_id, member_id).then(res => {
					if (handlereq(res)) {
						this.zhuanR_show = false;
						alertMess('操作成功', 'success')
						// 关闭推出
						this.drawershow = false
					}
				})
			},
			head_btnClick(index) {
				this.batch_edit = false
				if (index == 1) { //   转为客户
					if (this.is_powerEdit) {
						
						let member_id = localStorage.member_id || '';
						this.Transfer(this.customer_id, member_id)
					} else {
						alertMess('无权限操作', 'warning')
					}
					
				} else if (index == 2) { //  分配客户
					if (this.is_powerEdit) {
						this.zhuanR_show = true;
					} else {
						alertMess('无权限操作', 'warning')
					}
					
				} else if (index == 3) { //  编辑
					if (this.is_powerEdit) {
						this.edit_show1 = true
						this.create_show = true
						this.create_info.name = '编辑详细'
						this.savenew = false
						this.fn_getConfig(2)
					} else {
						alertMess('无权限操作', 'warning')
					}
					
				}
			},
			switchState(index) {
				if (index == 1) { // 删除
					if (this.is_powerDel) {
						this.release_gh(this.customer_id)
					} else {
						alertMess('无权限操作', 'warning')
					}
					
				}
			},
			// 转为客户
			Transfer(customer_id, member_id) {
				distributePublicCustomer(customer_id, member_id).then(res => {
					if (handlereq(res)) {
						alertMess('转为客户成功', 'success')
						this.drawershow = false
					}
				})
			},
			// 删除客户
			release_gh(customer_id) {
				this.$confirm('您确定要删除吗?')
					.then(() => {
						delPublicCustomer(customer_id).then(res => {
							if (handlereq(res)) {
								alertMess('删除成功', 'success')
								this.drawershow = false
							}
						})
					}).catch(() => {});
			},
			findField(field) {
				if (this.field_data.length > 0) {
					let index = this.field_data.findIndex(v => v.field == field)
					if (index != -1) {
						return this.field_data[index].content
					} else {
						return ''
					}
				}
			},
			findfont(field) {
				if (this.field_create.length > 0) {
					let index = this.field_create.findIndex(v => v.field == field)
					if (index != -1) {
						return this.field_create[index].content
					} else {
						return ''
					}
				}
			},
			findlxr(field_sign) {
				if (this.createlistlxr.length > 0) {
					let index = this.createlistlxr.findIndex(v => v.field_sign == field_sign)
					if (index != -1) {
						return this.createlistlxr[index].content
					} else {
						return ''
					}
				}
			},
		
			// 新建联系人
			createlxr(flag) {
				let name = this.findlxr('联系人姓名')
		
				let kh_name = this.findfont('客户名称')
				let kh_phone = this.findfont('电话')
				let kh_customer_type = this.findfont('客户类型') * 1
		
				if (!kh_name) {
					alertMess('请输入客户名称', 'error')
					this.$refs.reffield.create_page = 0
				} else if (!kh_phone) {
					alertMess('请输入电话', 'error')
					this.$refs.reffield.create_page = 1
				} else if (!kh_customer_type) {
					alertMess('请选择客户类型', 'error')
					this.$refs.reffield.create_page = 0
				} else if (!name) {
					alertMess('请输入联系人姓名', 'error')
					this.$refs.reffield.create_page = 0
				} else {
					let fd = new FormData()
					fd.append('name', name)
					let obj = this.createlistlxr
					let list = Basics_field(obj)
					if (obj.length) {
		
						fd.append('relation_type', 2)
		
						let phone = this.findlxr('手机')
						if (phone) {
							fd.append('phone', phone)
						}
						let source = this.findlxr('联系人来源')
						if (source) {
							fd.append('source', source)
						}
		
						let email = this.findlxr('邮箱')
						if (email) {
							fd.append('email', email)
						}
						//
						let assistant = this.findlxr('协同人')
						if (assistant.length > 0) { // 	否	string	协同人id	逗号间隔 加 逗号
							fd.append('assistant_member_id', assistant.join(',') + ',')
						}
						// 
		
						//
						let job = this.findlxr('职务')
						if (job) {
							fd.append('job', job)
						}
						let qq = this.findlxr('QQ号')
						if (qq) {
							fd.append('qq', qq)
						}
						let wx = this.findlxr('微信号')
						if (wx) {
							fd.append('wx', wx)
						}
						// 
		
						let gender = this.findlxr('性别')
						fd.append('gender', gender)
						fd.append('contact_info', JSON.stringify(list))
						if (this.edit_show1) {
							fd.append('customer_id', this.customer_id)
							fd.append('contact_id', this.currentContact.contact_id)
							lxrl_edit_contact(fd).then(res => {})
						} else {
							fd.append('customer_id', 9999999)
							lxrl_add_contact(fd).then(res => {
								if (handlereq(res)) {
									let id = res.result * 1
									this.creatse_kehu(id, flag)
								}
							})
						}
					}
				}
		
			},
		
			// 编辑 / 新建 保存  currentContact 
			headsaveer(e) {
				let {
					flag,
					arr,
				} = e
		
				//
				if (arr.length) {
					this.createlistlxr = arr
					this.createlxr(flag)
				}
				// 
				if (this.edit_show1) { // 编辑
		
					let name = this.findfont('客户名称')
					let phone = this.findfont('电话')
					let customer_type = this.findfont('客户类型') * 1
					if (!name) {
						alertMess('请输入客户名称', 'error')
						this.$refs.reffield.create_page = 0
					} else if (!phone) {
						alertMess('请输入电话', 'error')
						this.$refs.reffield.create_page = 1
					} else if (!customer_type) {
						alertMess('请选择客户类型', 'error')
						this.$refs.reffield.create_page = 0
					} else {
						let obj = this.field_create
						let list = Basics_kehu(obj)
		
						let fd = new FormData()
						fd.append('customer_id', this.customer_id)
						fd.append('customer_info', JSON.stringify(list))
						fd.append('customer_type', customer_type)
		
						fd.append('name', name)
						fd.append('phone', phone)
						
						fd.append('industry', this.findfont('企业行业'))
		
						let source = this.findfont('客户来源')
						fd.append('source', source)
		
						let email = this.findfont('邮箱')
						fd.append('email', email)
		
						let qy_name = this.findfont('企业名称')
						if (qy_name) {
							fd.append('qy_name', qy_name)
						}
		
		
						editCustome2(fd).then(res => {
							if (handlereq(res)) {
								this.edit_show1 = false
								this.create_show = false
								this.field_create = []
								alertMess('修改成功', 'success')
								this.drawershow = false
							}
						})
					}
				}
		
			},
			// 
		
		
			// 
			fieldpower(field_sign){
				if(this.fieldConfig.length) {
					let index1 = this.fieldConfig.findIndex(v=>v.field_sign == field_sign)
					if(index1 != -1) {
						return this.fieldConfig[index1].field_id
					}
					else {
						return '';
					}
				}
			},
			fn_getConfig(flag) {
				this.create_loading = true
				getCustomerInfoStoreConfig().then(res => {
					if (res.code === 10000) {
						let obj = res.result
						if (flag == 1) { // 新建
							let create = this.fn_fieldcreate(obj)
							this.field_create = create
							this.fn_getlxrlists(1)
						} else if (flag == 2) { // 编辑 客户类型
							this.fn_fieldedits(obj, flag)
							this.field_create = obj
							this.fn_getlxrlists(2)
						} else if (flag == 3) { // 显示
							this.fn_fieldedits(obj, flag)
							this.field_data = obj
						} else if (flag == 4) { // 批量 导入模板
							if (obj.length) {
								let batchArr = obj.filter(v => v.lock === 1)
								this.field_batch = obj
								this.import_show = true
							}
						}
		
		
						this.fieldConfig = obj
						this.page_power = {
							customer_name: fn_fielddisabled(this.fieldpower('客户名称'), this.curkey),
							phone: fn_fielddisabled(this.fieldpower('电话'), this.curkey),
							qy_name: fn_fielddisabled(this.fieldpower('企业名称'), this.curkey),
						}
						this.create_loading = false
						// -----------------------------------------
					}
				})
			},
			fn_findid(id) {
				if (this.field_initial.length > 0) {
					let index = this.field_initial.findIndex(v => v.config_id == id)
					if (index != -1) {
						return this.field_initial[index].content
					} else {
						return '';
					}
				}
			},
			fn_fieldedits(obj, flag) {
				if (obj.length) {
					for (let item of obj) {
						item.content = this.fn_findid(item.id)
						fn_newfield(item, true)
						//
						let disabled_val = fn_fielddisabled(item.id, this.curkey)
						item.is_show = disabled_val == 3 ? false : true;
						if(flag == 3) {
							item.disabled =  true
						}
						else {
							item.disabled = disabled_val == 2 ? true : false;
						}
						// 
		
						if (item.field == '客户来源') {
							item.field_list = this.source_select
							item.content = this.drawer_info.source
						} else if (item.field == '客户名称') {
							item.maxLength = 50
							if (this.drawer_info.customer_name) {
								console.log(this.drawer_info.customer_name, '客户名称')
								item.content = this.drawer_info.customer_name
							}
						} else if (item.field == '电话') {
							item.maxLength = 30
						} else if (item.field == '客户类型') {
							if (this.drawer_info.customer_type) {
								if (this.drawer_info.customer_type) {
									item.content = this.drawer_info.customer_type
								} else {
									item.content = ''
								}
							}
						} else if (item.field == '企业行业' || item.field == '性别') {
							if (item.content == 0) {
								item.content = ''
							}
						}
		
					}
					// currentContact
		
		
				}
			},
			fn_fieldcreate(obj) {
				if (obj.length) {
					let create = JSON.parse(JSON.stringify(obj))
					for (let item of create) {
						fn_newfield(item, false)
						
						item.is_show = true
		
						if (item.field == '客户名称') {
							item.maxLength = 50
						} else if (item.field == '电话') {
							item.maxLength = 30
						} else if (item.field == '客户来源') {
							item.field_list = this.source_select
							item.content = this.source_select[0].id
						}
					}
					return create
				}
			},
		
			// 获取联系人 字段 列表 basics_list
			find_currentCon(field_id) {
				let arr = []
				let contact_info = this.currentContact.contact_info
				if (contact_info && typeof(contact_info) == 'string') {
					arr = JSON.parse(contact_info) || []
				}
		
				if (arr.length > 0) {
					let index = arr.findIndex(v => v.field_id == field_id)
					if (index != -1) {
						console.log(arr[index].content, 'find_currentCon')
						return arr[index].content
					} else {
						return ''
					}
				}
			},
			fn_getlxrlists(iflag) {
				lxr_list2confield().then(res => {
					if (res.code === 10000) {
						let obj = res.result
						if (obj.length) {
							// currentContact contact_info2
							for (let item of obj) {
		
								fn_newfield(item, false)
								//
								let disabled_val = fn_fielddisabled(item.field_id, 'seas_customer_contact')
								item.is_show = disabled_val == 3 ? false : true;
								if(iflag == 1) {
									item.lxr_checked = false
								}
								else {
									item.lxr_checked = disabled_val == 2 ? true : false;
								}
								//
		
								//
								let field_sign = item.field_sign
								let filerlist = [
									'邮箱', '微信号', 'QQ号', '职务',
								]
								let flagfiler = filerlist.some(v => v == field_sign)
								if (flagfiler) {
									item.field_type = 1
								}
								if (field_sign == '联系人姓名') {
									item.field_type = 1
									item.maxLength = 50
								} else if (field_sign == '联系人来源') {
									item.field_type = 5
									item.field_list = this.source_select
									item.content = this.source_select[0].id
								} else if (field_sign == '手机') {
									item.field_type = 1
									item.maxLength = 30
								} else if (field_sign == '生日') {
									item.field_type = 3
								} else if (field_sign == '性别') {
									item.field_type = 5
									item.field_list = [{
											id: 1,
											name: '男'
										},
										{
											id: 2,
											name: '女'
										},
										{
											id: 3,
											name: '未知'
										},
									]
									item.content = 1
								}
								else if (field_sign == '协同人') {
									item.field_type = 11
									item.content = []
								} 
		
								if (this.currentContact) {
									item.content = this.find_currentCon(item.field_id)
									if (field_sign == '联系人姓名') {
										item.content = this.currentContact.name || '';
									} else if (field_sign == '手机') {
										item.content = this.currentContact.phone || '';
									}
									else if (field_sign == '协同人') {
										
										if (this.currentContact.assistant_member && this.currentContact.assistant_member.length) {
											let narr = this.currentContact.assistant_member_id.split(',')
											let arr1 = []
											for (let ei of narr) {
												if (ei) {
													arr1.push(ei * 1)
												}
											}
											item.content = arr1
										} else {
											item.content = []
										}
									}
									if (item.field_type == 3 || field_sign == '生日') { // 时间
										let val = this.find_currentCon(item.field_id)
										item.content = (val + '').length > 10 ? val : val * 1000;
									}
								}
		
								// 
							}
		
							console.log(obj, 'obj')
							let ele1 = {
								field: '创建联系人',
								field_type: 16,
								type: 1,
								lxr_list: obj,
								checkshow: true,
								is_show: true,
		
							}
		
							this.field_create.push(ele1)
		
						}
					}
					// this.lxr_loading = false
				})
			},
			// 
			// 获取联系人 分类 列表 basics_list
			fn_getgroupList() {
				lxr_listcongroup().then(res => {
					if (handlereq(res)) {
						let obj = res.result.data
						if (obj.length) {
							for (let item of obj) {
								item.type = item.group_id
							}
							this.basics_list = obj
		
						}
					}
		
				})
			},
			// 获取详情
			fn_getDelait() {
				get_qw_customer_details(this.userid).then(res => {
					if (handlereq(res)) {
						setTimeout(()=>{
							console.log(res,'get_qw_customer_details')
						}, 1000)
						
						let obj = res.result
		
						if (obj.customer_info && typeof(obj.customer_info) === 'string') {
							let jos = handErrJson(obj.customer_info)
							let info = JSON.parse(jos)
							this.field_initial = info
							let index1 = info.findIndex(v => v.field == '企业名称')
							if (index1 != -1) {
								obj.qy_name = info[index1].content || ''
							}
						
						}
		
						let newArr = []
						if (obj.assistant_member_id) {
							for (let ie of obj.assistant_member) {
								newArr.push(ie.name)
							}
						}
						obj.title_member = newArr.join(',')
						this.drawer_info = obj
						this.customer_id = obj.customer_id
					}
		
		
					this.$refs.sfdrawer.isloading = false
					this.tactshow = true
				})
			},
			// 修改标签成功
			fnsuccess() {
				this.labelshow = false
				this.fn_getDelait()
		
			},
			// 获取客户来源
			fn_follow_up_list() {
				this.source_select = []
				getfollow_up_list().then(res => {
					if (res.code === 10000) {
						this.source_select = res.result.data
					}
				})
			},

		}
			
	}
</script>

<style scoped lang="scss">
	@import "@/assets/css/public.scss";
</style>